import CASL from '@/utils/constants/casl'

export default {
  path: 'pln',
  children: [
    {
      path: '',
      name: 'pln.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.PROSES_PLN
      },
      component: () => import('./list/PlnListPage.vue')
    },
    {
      path: ':uid',
      name: 'pln.detail',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.PROSES_PLN
      },
      component: () => import('./form/PlnFormPage.vue')
    }
  ]
}
